import { User, TrendingUp } from "lucide-react"
import { Badge, Typography } from "@/components/design-system"
import Link from "next/link"
import { IGenerator } from "@/constants/categories"
import { useLocaleNavigation } from "@/lib/navigation"
import React from "react"
import { useLocale } from "next-intl"
export default function GeneratorCard({
    generator,
    isPopular = false
}: {
    generator: IGenerator
    isPopular?: boolean
}) {
    const { getNavigationPath } = useLocaleNavigation();
    const locale = useLocale();

    return (
        <Link 
            href={getNavigationPath(generator.id)} 
            className="group block h-full"
        >
            <div className="relative h-full p-6 rounded-2xl bg-gradient-to-br from-card to-card/50 border border-border/50 shadow-lg hover:shadow-2xl transition-all duration-500 group-hover:scale-105 group-hover:border-primary/30 overflow-hidden">
                {/* Background gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Popular badge */}
                {isPopular && (
                    <div className="absolute top-4 right-4 z-10">
                        <Badge variant="secondary" className="px-2 py-1 text-xs font-medium">
                            <TrendingUp className="w-3 h-3 mr-1" />
                            Popular
                        </Badge>
                    </div>
                )}

                {/* Icon container */}
                <div className="relative z-10 mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-primary/20 to-primary/10 rounded-xl flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-primary/30 group-hover:to-primary/20 transition-all duration-300">
                        {React.cloneElement(generator.icon, { 
                            className: 'h-7 w-7 text-primary group-hover:scale-110 transition-transform duration-300' 
                        } as any)}
                    </div>
                </div>

                {/* Content */}
                <div className="relative z-10 space-y-3">
                    <Typography variant="h4" className="text-xl font-bold group-hover:text-primary transition-colors duration-300">
                        {generator.name[locale]}
                    </Typography>
                    <Typography variant="muted" className="text-sm leading-relaxed">
                        {generator.description[locale]}
                    </Typography>
                </div>

                {/* Decorative corner element */}
                <div className="absolute top-3 right-3 w-6 h-6 border-t-2 border-r-2 border-primary/20 rounded-tr-lg group-hover:border-primary/40 transition-colors duration-300" />
            </div>
        </Link>
    )
}